import _get from 'lodash/get';

export default function getOptionsFromSelectedIds(
  selectedIds: string[],
  currentOptions: Record<string, unknown>[],
) {
  const existingByDocId = new Map(
    currentOptions
      .filter((opt) => _get(opt, 'optionDocumentation.documentationId'))
      .map((opt) => [
        _get(opt, 'optionDocumentation.documentationId') as string,
        opt,
      ]),
  );

  return selectedIds.map((docId, index) => {
    const existing = existingByDocId.get(docId);
    return {
      values: [docId],
      position: index,
      optionDocumentation: {
        documentationId: docId,
        requiredToRead: existing
          ? (_get(
              existing,
              'optionDocumentation.requiredToRead',
              true,
            ) as boolean)
          : true,
      },
    };
  });
}
